var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9083 13.4323C22.6486 15.4118 21.8549 17.2834 20.6121 18.8461C19.3694 20.4089 17.7246 21.6041 15.8541 22.3033C13.9836 23.0026 11.958 23.1797 9.99449 22.8155C8.03099 22.4513 6.20369 21.5597 4.70856 20.2362C3.21343 18.9127 2.10687 17.2073 1.50756 15.3028C0.908242 13.3984 0.838785 11.3668 1.30663 9.42585C1.77448 7.48494 2.76199 5.70797 4.16324 4.2855C5.56449 2.86303 7.32663 1.84874 9.26067 1.35139C14.6221 -0.023321 20.1719 2.73572 22.2207 7.87712M23.0005 1.00352V7.87706H16.1251",
    stroke: "#3C6D79",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.85cc2b3354fd9e8b886485a7e0983692.svg";
export { ForwardRef as ReactComponent };